
import { ReSession } from '../../interfaces/types';
import { Accordion, AccordionDetails, AccordionSummary, Box, Divider, Stack, Typography } from '@mui/material';
import { useCustomThemeContext } from '../../providers/customThemeProvider';
import { FC, useEffect, useState } from 'react';
import ReviewForm from './ReviewForm';
import ReviewList from './ReviewList';
import { useReviewContext } from '../../providers/ReviewProvider';
import { ExpandMore } from '@mui/icons-material';
import { useEventContext } from '../../providers/EventProvider';
import { usePermissionContext } from '../../providers/PermissionProvider';
import { useUserContext } from '../../providers/userProvider';

interface ReviewColumnProps {
    session: ReSession;
}

const ReviewColumn: FC<ReviewColumnProps> = ({ session }) => {
    const { theme } = useCustomThemeContext();
    const { userDetails } = useUserContext();
    const { getReviewsForSession } = useReviewContext();
    const { getEventBySessionId } = useEventContext();
    const { hasReviewCreatePermission } = usePermissionContext();
    const [reviews, setReviews] = useState(getReviewsForSession(session));
    const [currentEvent, setCurrentEvent] = useState(getEventBySessionId(session.id));
    const defaultExpanded = !reviews.some(review => review.createdBy === userDetails?.uid);

    useEffect(() => {
        const event = getEventBySessionId(session.id);
        setCurrentEvent(event);
    }, [session.id]);

    useEffect(() => {
        setReviews(getReviewsForSession(session));
    }, [session, getReviewsForSession]);

    return (
        <Box sx={{ display: 'flex', flexDirection: 'row', flexGrow: 1, alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%' }}>
            <Stack spacing={1} height={'100%'} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center', width: '100%' }}>       

                {currentEvent && currentEvent.eventConfiguration.isReviewCreationActive && hasReviewCreatePermission(currentEvent.id) &&
                    <Accordion 
                    defaultExpanded={defaultExpanded}
                        sx={{ width: '100%' }}>
                        <AccordionSummary
                            expandIcon={<ExpandMore />}
                            aria-controls="panel1-content"
                            id="panel1-header"
                        >
                            <Typography variant='h6' component="span" color={theme.palette.primary.main}>SUBMIT REVIEW</Typography>
                        </AccordionSummary>
                        <AccordionDetails >
                            <ReviewForm session={session} />
                        </AccordionDetails>
                    </Accordion>
                }

                {reviews && reviews.length > 0 && <Accordion defaultExpanded sx={{ width: '100%', flexGrow: 1 }}>
                    <AccordionSummary
                        expandIcon={<ExpandMore />}
                        aria-controls="panel2-content"
                        id="panel2-header"
                    >
                        <Typography variant='h6' component="span" color={theme.palette.primary.main}>VIEW REVIEWS</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <ReviewList reviews={reviews} />
                    </AccordionDetails>
                </Accordion>}

            </Stack>
        </Box>
    );
};

export default ReviewColumn;